export const fetchAssignmentSharedWithSelectors = {
    byUserId: (arg, result) => ({
        ...result,
        data: result?.data?.find(sharedWith => sharedWith.user?.id === arg.id)?.user,
    }),
    selectMyOrganizationSharing: (arg, result) => ({
        ...result,
        data: result?.data?.find(sharedWith => sharedWith.organization?.id === arg.id),
    }),
    selectSharedWithListWithoutMyOrganization: (arg, result) => ({
        ...result,
        data: result?.data?.filter(sharedWith => sharedWith.organization?.id !== arg.id),
    }),
    selectOnlyUsers: result => ({
        ...result,
        data: result?.data?.filter(sharedWith => sharedWith.user)?.map(sharedWith => sharedWith.user),
    }),
}
